// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Toyb","fullView":"styles_fullView__2oHEm"};